import { Grid } from '@mui/material';
import { useParams } from 'react-router';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { PageWrapper } from '../../common/components/PageWrapper';
import TopAppBar from '../../common/components/TopAppBar';
import { orderAtom } from '../state/state';
import { RoutePaths } from '../../routes/AppRoutes';
import BasketButton from '../../basket/BasketButton';
import OrderInformation from './OrderInformation';
import OrderProvider from './OrderProvider';
import OrderPackagings from './OrderPackagings';
import OrderStatus from './OrderStatus';
import OrderPackagingWeightUpdate from './OrderPackagingWeightUpdate';
import OrderTertiaryAction from './OrderTertiaryAction';

export default function OrderTrackingPage(): React.JSX.Element {
  const { orderReferenceId } = useParams();
  const { t } = useTranslation(['common']);
  const order = useAtomValue(orderAtom);

  return (
    <>
      <TopAppBar
        configuration="small"
        backTo={RoutePaths.ORDER_LIST}
        title={`${t('common:order')} #${order.friendly_id}`}
        trailingAction={(
          <BasketButton />
        )}
      />
      <PageWrapper
        sx={{
          pt: {
            xs: 0.5,
            lg: 2,
          },
        }}
      >
        {orderReferenceId && (
          <OrderProvider orderReferenceId={orderReferenceId}>
            <Grid container spacing={2} sx={{ alignItems: 'start' }}>
              <Grid size={{ xs: 12, lg: 4, xl: 3 }}>
                <OrderInformation />
              </Grid>
              <Grid
                size={{ xs: 12, lg: 8, xl: 9 }}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                <OrderStatus />
                <OrderTertiaryAction />
                <OrderPackagingWeightUpdate />
                <OrderPackagings />
              </Grid>
            </Grid>
          </OrderProvider>
        )}
      </PageWrapper>
    </>
  );
}
